var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "50.000000pt",
    height: "50.000000pt",
    viewBox: "0 0 50.000000 50.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,50.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116 464 c-24 -23 -24 -405 0 -428 23 -23 245 -23 268 0 24 23 24 405 0 428 -23 23 -245 23 -268 0z m44 -35 c6 -23 9 -24 90 -24 81 0 84 1 90 25 3 14 12 25 20 25 13 0 15 -32 15 -205 l0 -205 -125 0 -125 0 -3 195 c-1 107 0 201 3 208 8 20 29 9 35 -19z m163 11 c-5 -18 -14 -20 -73 -20 -59 0 -68 2 -73 20 -5 19 0 20 73 20 73 0 78 -1 73 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210 440 c0 -5 11 -10 25 -10 14 0 25 5 25 10 0 6 -11 10 -25 10 -14 0 -25 -4 -25 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270 440 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.3a669c1585338697a456ccd1e717d4c9.svg";
export { ForwardRef as ReactComponent };